<!-- 移动端的最外层容器，包括页面顶部的菜单栏 -->
<template>
  <div class="mob-wrap">
    <div class="mob-header">
      <p>政府采购评价系统</p>
      <div
        class="needsclick"
        @touchstart="gtouchstart()"
        @touchmove="gtouchmove()"
        @touchend="showDeleteButton()"
        @dblclick="logout"
      >
        <van-icon name="manager" />{{ userName }}
      </div>
      <div class="tip" v-show="isTip">
        <p>长按姓名可以退出系统</p>
      </div>
    </div>
    <div class="mob-body">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    userName: {
      type: String,
      default: "expert",
    },
  },
  data() {
    return {
      isTip: false,
      timeOutEvent: null,
    };
  },
  mounted() {
    this.isTip = true;

    setTimeout(() => {
      this.isTip = false;
    }, 2000);
  },
  methods: {
    logout() {
      this.$router.replace("/login");
    },
    //长按事件（起始）
    gtouchstart() {
      let self = this;
      this.timeOutEvent = setTimeout(function () {
        self.longPress();
      }, 1000); //这里设置定时器，定义长按500毫秒触发长按事件
      return false;
    },
    //手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
    showDeleteButton() {
      clearTimeout(this.timeOutEvent); //清除定时器
      if (this.timeOutEvent != 0) {
        //这里写要执行的内容（如onclick事件）
      }
      return false;
    },
    //如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    gtouchmove() {
      clearTimeout(this.timeOutEvent); //清除定时器
      this.timeOutEvent = 0;
    },
    //真正长按后应该执行的内容
    longPress() {
      this.timeOutEvent = 0;
      //执行长按要执行的内容，如弹出菜单
      this.logout();
    },
  },
};
</script>
<style lang="less" scoped>
.mob-wrap {
  background-color: #f7f8fa;
  height: 100%;
  max-width: 500px;
  margin: auto;
  overflow: hidden;
  .mob-header {
    width: 100%;
    max-width: 500px;
    height: 3.4rem;
    background-color: #fff;
    box-shadow: 0 1px 14px 0 rgba(87, 87, 87, 0.103);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 4;
    user-select: none;
    -webkit-touch-callout: none !important;
    -webkit-user-select: none;

    & > p {
      font-size: 1.2rem;
      font-weight: bold;
      font-family: "宋体";
      color: rgb(74, 166, 228);
    }
    span {
      font-size: 0.9rem;
      color: #888;
    }
    .van-icon {
      color: #999;
      padding-right: 0.3rem;
    }

    .tip {
      position: absolute;
      bottom: -25px;
      right: 1rem;
      width: auto;
      padding: 0.5rem;
      background-color: rgba(46, 46, 46, 0.829);
      font-size: 0.8rem;
      border-radius: 4px;
      color: #fff;

      &::before {
        content: "";
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 10px solid rgba(46, 46, 46, 0.829);
        position: absolute;
        top: -9px;
        right: 10px;
      }
    }
  }
  .mob-body {
    margin-top: 4.5rem;
    height: calc(100% - 4rem);
    overflow: auto;
  }
}
</style>